module.exports = __webpack_public_path__ + "files/d92e81e41388579efe836483d8e7674a.svg";